<template>
  <RecentlyViewedLinksSkeleton v-if="pending" />
  <div
    v-else
    class="flex overflow-x-auto md:flex-wrap scrollbar-none gap-8 mt-4 md:mt-12 mb-16 -mx-24 px-24 py-4 md:px-40 md:mx-0"
  >
    <RevButtonBase
      v-for="(link, index) in links"
      :key="link.id"
      :to="link.url"
      :aria-label="link.title"
      class="relative block text-onaction-default-mid hover:bg-action-default-mid-hover bg-action-default-mid rounded-full border-1 border-transparent outline-2 outline-offset-4 focus-visible:outline-default-hi motion-safe:transition motion-safe:duration-[225ms] label-large h-40 px-16 [@media(pointer:coarse)]:h-48 [@media(pointer:coarse)]:px-12"
      @click="emit('click-link', link, index)"
    >
      <div class="flex items-center gap-4 h-full">
        <component :is="icons[link.entryType]" class="shrink-0" />
        <q
          v-if="link.entryType === 'search-query'"
          class="px-2 inline-flex items-baseline"
        >
          <span class="truncate max-w-[30ch]">{{ link.title }}</span>
        </q>
        <div v-else class="px-2">
          <span class="truncate max-w-[30ch]">{{ link.title }}</span>
        </div>
      </div>
    </RevButtonBase>
  </div>
</template>

<script setup lang="ts">
import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconProductCollection } from '@ds/icons/IconProductCollection'
import { IconSearch } from '@ds/icons/IconSearch'

import type {
  RecentlyViewedPlp,
  RecentlyViewedSearch,
} from '../../../../composables/useRecentlyViewedPages/useRecentlyViewedPages.types'

import RecentlyViewedLinksSkeleton from './components/RecentlyViewedLinksSkeleton/RecentlyViewedLinksSkeleton.vue'

type RecentlyViewedLinkPage = RecentlyViewedSearch | RecentlyViewedPlp

defineProps<{
  links: RecentlyViewedLinkPage[]
  pending: boolean
}>()

const emit = defineEmits<{
  'click-link': [link: RecentlyViewedLinkPage, index: number]
}>()

const icons = {
  'search-query': IconSearch,
  plp: IconProductCollection,
} as const
</script>
